export enum MessageType {
  Error = 'error',
  Success = 'success',
  Info = 'info'
}

export interface AlertMessage {
  type: MessageType,
  text: string
}
